import ModalContentFormModule from './containers/modalContentFormModule'

export {default as ModalContentFormModuleLayout} from './components/modalContentFormModuleLayout'

export default ModalContentFormModule
